/**
 * Edit API key: business-error model + mapper.
 *
 * The Edit flow surfaces the same shape of failure as the other form slices: a
 * coarse infra failure (`network` | `api`, from the app-wide `@/utils/infra-error`)
 * OR a business `validation` failure carrying per-field messages. The union is
 * local (only Edit has a form), and the mapper pins the Edit-flow default
 * message. Infra/unexpected errors are not modelled here (they bubble to the
 * generic handler).
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

import type { ValidationErrors } from './api-key-draft.model';

export type EditApiKeyError =
  | InfraFailure
  | { kind: 'validation'; fields: ValidationErrors };

export function toEditApiKeyError(e: unknown): EditApiKeyError {
  return classifyInfraError(e, 'Failed to update API key.');
}
